import { DashboardEditForm, type EditFormProps } from "./DashboardEditForm";
import { DashboardViewRow } from "./DashboardViewRow";
import { type DashboardRow } from "./types";

export function DashboardListItem({
  d,
  editingId,
  onStartEdit,
  onArchiveToggle,
  onDelete,
  onDuplicate,
  ...editFormProps
}: EditFormProps & {
  d: DashboardRow;
  editingId: string | null;
  onStartEdit: (d: DashboardRow) => void;
  onArchiveToggle: (id: string, archived: boolean) => void;
  onDelete: (id: string) => void;
  onDuplicate?: () => void;
}) {
  if (editingId === d.id) return <DashboardEditForm {...editFormProps} />;
  return (
    <DashboardViewRow
      d={d}
      onStartEdit={onStartEdit}
      onArchiveToggle={onArchiveToggle}
      onDelete={onDelete}
      onDuplicate={onDuplicate}
    />
  );
}
